import querystring from 'querystring';
import {
  Link,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from 'react-router-dom';

import enums from '../../helpers/enums';
import formatters from '../../helpers/formatters';
import useApi from '../../helpers/useApi';

import CustomPie from '../../components/CustomPie';
import TableInfo from '../../components/TableInfo';

import Timeline from './Timeline';

const Factory = () => {
  const { path, url } = useRouteMatch();

  return (
    <>
      <h1>Single factory statistics</h1>
      <div className='navigation-container'>
        <Link to={`${url}`} className='navigation-item'>Overview</Link>
        <Link to={`${url}/timeline`} className='navigation-item'>Timeline</Link>
      </div>
      <Switch>
        <Route exact path={`${path}/`}>
          <Overview />
        </Route>
        <Route path={`${path}/timeline`}>
          <Timeline />
        </Route>
      </Switch>
    </>
  );
};

export default Factory;

const Overview = () => {
  const history = useHistory();

  const { isLoading, data } = useApi('analytics/production/factory/overview');

  if (isLoading) {
    return (
      <div>Loading....</div>
    );
  }

  const rows = [
    {
      label: 'ID',
      value: data.factory.id,
    },
    {
      label: 'Name',
      value: enums.factory[data.factory.id].label,
    },
    {
      label: 'Total tests',
      value: data.factory.count_tests,
      onClick: () => history.push({
        pathname: '/analytics/production/events',
        search: querystring.stringify({ factories: [data.factory.id] }),
      }),
    },
    {
      label: 'Passed tests',
      value: data.factory.count_tests_passed,
      onClick: () => history.push({
        pathname: '/analytics/production/events',
        search: querystring.stringify({ factories: [data.factory.id], testResult: ['passed'] }),
      }),
    },
    {
      label: 'Failed tests',
      value: data.factory.count_tests_failed,
      onClick: () => history.push({
        pathname: '/analytics/production/events',
        search: querystring.stringify({ factories: [data.factory.id], testResult: ['failed'] }),
      }),
    },
    {
      label: 'Jig count',
      value: data.factory.count_jigs,
      onClick: () => history.push({
        pathname: '/analytics/production/jigs',
        search: querystring.stringify({ factories: [data.factory.id] }),
      }),
    },
    {
      label: 'Module count',
      value: data.factory.count_modules,
      onClick: () => history.push({
        pathname: '/analytics/production/modules',
        search: querystring.stringify({ factories: [data.factory.id] }),
      }),
    },
    {
      label: 'Avg. tests per test module',
      value: formatters.float(data.factory.avg_tests_per_module),
    },
  ];

  return (
    <>
      <div className='stats-main-container'>
        <div className='charts-container'>
          <TableInfo rows={rows} />
          <CustomPie
            title='Passed vs. failed tests'
            data={[
              {
                name: 'passed',
                count: data.factory.count_tests_passed,
              },
              {
                name: 'failed',
                count: data.factory.count_tests_failed,
              },
            ]}
            dataKey='count'
            nameKey='name'
            enumName='testResult'
          />
          <CustomPie
            title='Tests per module'
            data={data.statsOverviewPerModule}
            dataKey='count'
            nameKey='module_num'
            enumName='module'
          />
        </div>
      </div>
    </>
  );
};
